import { createCookie } from '@shared/cookies/createCookie';
import {
  UtiqConsentVersionEntryName,
  UtiqConsentVersionPreviousEntryName,
} from '@shared/constants/utiq';
import { encodeToBase64 } from '@shared/conversion/encodeToBase64';
import { getBaseDomain } from '@shared/domain/getBaseDomain';

export const setVersionCookies = (
  consentVersion: number | boolean = false,
  days: number = 0,
  consentVersionPrevious: number | boolean = consentVersion,
) => {
  document.cookie = createCookie({
    name: UtiqConsentVersionEntryName,
    value: encodeToBase64(consentVersion),
    days: days,
    domain: getBaseDomain(window.location.hostname),
  });
  document.cookie = createCookie({
    name: UtiqConsentVersionPreviousEntryName,
    value: encodeToBase64(consentVersionPrevious),
    days: days,
    domain: getBaseDomain(window.location.hostname),
  });
};
